<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>&copy; {{ new Date().getFullYear() }} <a href="https://rockware.com.br" target="_blank" rel="nofollow">Rockware</a>. Todos os direitos reservados.</span>
        <span class="md:flex hidden items-center">
            <span>
                {{ SYS_VERSION }}
            </span>
            <!-- <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> -->
        </span>
    </footer>
</template>

<script>
    import { SYS_VERSION }     from '@/assets/utils/constants.js'

    export default {
        name: "the-footer",

        props: {
            classes: {
                type: String,
            },
            sysVersion : {
                type: String
            }
        },

        created () {
            this.SYS_VERSION = SYS_VERSION
        }
    }
</script>
